import React, { Component } from 'react';
import navDeposit from '../../payment/navdeposit/index.js';
import pendingwithdrawals from '../../payment/pendingwithdrawals/index.js';
import { closeStepsDepositflow, confAccountPendingWithdrawals as conf } from '../../payment/common/lib/utils/router-config.js';

class AccountPendingWithdrawals extends Component {
	componentWillMount() {
		closeStepsDepositflow({
			bonus: true,
			pendingwithdrawals: false,
			payment: true
		});
		navDeposit.init(conf);
		pendingwithdrawals.init({
			wrapElmSelector: '#js-deposit-pendingwithdrawals',
			origin: 'account'
		});
	}

	render() {
		return (
			<div id="upload-documents" />
		);
	}
}

export default AccountPendingWithdrawals;



// WEBPACK FOOTER //
// ./mobile-core/src/components/account/account-pending-withdrawals.js